'use strict';

const _=require('pulsar-utils/dist-es6/_');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const ComplianceDescriptions=require('pulsar-compliance/dist-es6/complianceDescriptions');


const _MaxRedMs=timespan.fromHours(1).totalMilliseconds();let



AssessmentsExtensions=class AssessmentsExtensions{

constructor(self){
this._self=self;
}


getAlertRangesFor(bounds){
const alertRanges=_getFreshAlertIntervals();
if(this._self.length===0){
return alertRanges;
}

const failedPvtTerminators=this._self.filter(a=>a.status==='Fail').map(a=>_failedPvtTerminatorFor(a));
const startAndEndMarkers=this.asStartAndEndMarkers();

let inShift=_.get(startAndEndMarkers,'0.tag')==='_shiftEnd';

const toWalkThrough=_(this._self).
filter(a=>a.status!=='Missed').
concat(failedPvtTerminators).
concat(startAndEndMarkers).
concat(_endOfShiftMarkerFor({reasonTime:bounds.end})).
sortBy(post=>post.time).
takeWhile(post=>post.time.getTime()<=bounds.end.getTime()).
value();

let previous=void 0;
for(const next of toWalkThrough){
if(next.tag==='_failedPvtTerminator'&&next.assessment!==previous){
continue;
}
if(inShift&&previous){
switch(previous.status){
case'Fail':
const startTime=previous.reason===ComplianceDescriptions.shiftStart?_.maxDate([previous.time,previous.reasonTime]):previous.time;
alertRanges.Above.push(TimeInterval.from(startTime).to(next.time));
break;
case'Not Complete':
alertRanges.At.push(TimeInterval.from(previous.time).to(next.time));
break;
default:
break;}

}
if(next.tag==='_shiftEnd'){
inShift=!1;
previous=void 0;
}else if(next.tag==='_shiftStart'){
inShift=!0;
previous=previous===next.assessment?previous:void 0;
}else{
previous=next;
}
}

return _.mapValues(alertRanges,intervals=>TimeInterval.clip(TimeInterval.compress(intervals)).to(bounds));
}

asStartAndEndMarkers(){
const startOfShiftMarkers=this._self.filter(a=>a.reason===ComplianceDescriptions.shiftStart).map(a=>_startOfShiftMarkerFor(a));
const endOfShiftMarkers=this._self.filter(a=>a.reason===ComplianceDescriptions.shiftEnd).map(a=>_endOfShiftMarkerFor(a));
return _(startOfShiftMarkers).concat(endOfShiftMarkers).sortBy(m=>m.time.getTime()).value();
}


asShifts(){
const shifts=[];
let shiftStart=void 0;
for(const marker of this.asStartAndEndMarkers()){
if(marker.tag==='_shiftStart'){
shiftStart=marker.time;
}else if(shiftStart&&marker.tag==='_shiftEnd'){
shifts.push(TimeInterval.from(shiftStart).to(marker.time));
shiftStart=void 0;
}
}
return shifts;
}



filterOutFutureShifts({now,currentShift}){
return this._self.filter(a=>
a.time.getTime()<=now.getTime()||
currentShift&&(a.reasonTime||a.time).getTime()<=currentShift.end.getTime());

}


static extend(assessments){
return new AssessmentsExtensions(assessments);
}};


module.exports=AssessmentsExtensions.extend;


AssessmentsExtensions.extend.getPastShifts=getPastShifts;


function getPastShifts({shifts,currentShift,now}){
return _(shifts).takeWhile(s=>s.start.getTime()<(currentShift?currentShift.start.getTime():now.getTime())).value();
}

const _getFreshAlertIntervals=()=>({
Above:[],
At:[],
Below:[],
NotApplicable:[]});



function _failedPvtTerminatorFor(assessment){
return{
time:new Date(assessment.time.getTime()+_MaxRedMs),
tag:'_failedPvtTerminator',
assessment};

}


function _startOfShiftMarkerFor(assessment){
return{
time:assessment.reasonTime,
tag:'_shiftStart',
assessment};

}


function _endOfShiftMarkerFor(assessment){
return{
time:assessment.reasonTime,
tag:'_shiftEnd',
assessment};

}
//# sourceMappingURL=assessmentsExtensions.js.map
